import { render } from "./RaiseNotice.vue?vue&type=template&id=27e43be7"
import script from "./RaiseNotice.vue?vue&type=script&lang=js"
export * from "./RaiseNotice.vue?vue&type=script&lang=js"

import "./RaiseNotice.vue?vue&type=style&index=0&id=27e43be7&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__